<template>
  <CardRow
    :label="label"
    :value="value?.name"
    :disabled="disabled"
    :error-messages="errorMessages"
    :required="required"
    :hideBorderBottom="hideBorderBottom"
  >
    <v-radio-group
      v-model="dataValue"
      dense
      :required="!disabled"
      :mandatory="mandatory"
    >
      <v-radio
        v-for="form in valueList"
        :key="form.name"
        :label="`${form.name}`"
        :value="form"
        :disabled="disabled"
        :ripple="false"
      />
    </v-radio-group>
  </CardRow>
</template>

<script>
import CardRow from './CardRow'
import { formatDateReverseFromISO } from '../../../scripts'

export default {
  name: 'CardDateRow',

  props: {
    label: String,
    value: {
      type: String | null,
      default: true
    },
    mandatory: {
      type: Boolean,
      default: true
    },
    type: {
      String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Введите значение'
    },
    valueList: {
      type: Array,
      default() {
        return []
      }
    }
  },

  components: {
    CardRow
  },

  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },

    formatDate() {
      return formatDateReverseFromISO(this.dataValue)
    }
  }
}
</script>

<style scoped></style>
